import Page from './src/page.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';
export const ToPage: SFCWithInstall<typeof Page> = withInstall(Page);
export * from './src/instance';
